import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_editTopNavigationLink, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_website_cms_editTopNavigationLink';

export type TransactionItemType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Response200Type  => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface NavigationLinkType {
    title: string,
    event_id: string,
    img_url: string,
    date_from: string,
    date_to: string,
    is_active: boolean,
    universe: string,
    sport: string | null | undefined,
    competition_id: number | null | undefined,
    action_template: string,
    cta_url: string | null | undefined,
    display_order: number | null | undefined,
    visibility: string
}

export interface PutNavigationLinkType {
    navigationLink: NavigationLinkType,
    id: number
}

export const putHeaderNavigationLink = {
    browser: {
        params: (params: PutNavigationLinkType): ParamsFetchType<PutNavigationLinkType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/put-header-link',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/put-header-link',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<PutNavigationLinkType>): Promise<GenerateUrlApiType> => {

        const resp = await openapi_website_cms_editTopNavigationLink(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            body: params.req.body.navigationLink,
            id: params.req.body.id
        });

        return {
            passToBackend: false,
            status: resp.status,
            responseBody: resp.body,
        };
    }
};
